import {CustomFieldDefinition, CustomFieldOption} from "@/shared/timr";
import {CustomFieldsForRecordType} from "@/shared/timrTypes";
import {formatCustomField} from "@/shared/utils/misc";
import {Combobox} from "@/shared/ui/combobox";

type CustomFields = {
	customField1: string | null;
	customField2: string | null;
	customField3: string | null;
	customField4: string | null;
	customField5: string | null;
	customField6: string | null;
	customField7: string | null;
};

const MAX_CUSTOM_FIELDS = 7;
export function removeCustomFieldValues(container: JQuery) {
	for (let i = 1; i <= MAX_CUSTOM_FIELDS; i++) {
		container.find(`[name="customField${i}"]`).val("");
	}
}

export function initCustomFields(container: JQuery, customFieldDefinitions: CustomFieldDefinition[], customFieldComboboxes: Combobox<CustomFieldOption>[], hasCustomFieldCheckboxChangeListener: boolean[]) {
	let i = 0;
	const createCustomFieldComboboxes = customFieldComboboxes.length === 0;
	for (const definition of customFieldDefinitions) {
		if (definition.fieldType === CustomFieldsForRecordType.Options && definition.fieldName) {
			const customFieldComboboxItems: CustomFieldOption[] = [];
			for (const item of definition.optionsList ?? []) {
				customFieldComboboxItems.push({id: item});
			}
			if (createCustomFieldComboboxes) {
				customFieldComboboxes.push(new Combobox<CustomFieldOption>({
					items: customFieldComboboxItems,
					formatter: (item) => {
						return item.id;
					},
					idElement: container.find(`[name="customField${definition.fieldNumber}"]`),
					filterElement: container.find(`[id^=custom][id$=Field${definition.fieldNumber}FilterDialog]`),
					caretElement: container.find(`[id="customField${definition.fieldNumber}Caret"]`),
					clearable: !definition.mandatory,
					emptyMessage: definition.mandatory ? messages["recording.customFieldCombobox.empty"] : ""
				}));
			} else {
				customFieldComboboxes[i].clearSelection();
				customFieldComboboxes[i].updateItems(customFieldComboboxItems);
			}
			i++;
		}
		const customField = container.find(`[name="customField${definition.fieldNumber}"]`);
		if (!customField.hasClass("comboboxRow")) {
			const customFieldNumber = container.find(`[name="customField${definition.fieldNumber}Number"]`);
			if (customFieldNumber.length) {
				customFieldNumber.val("");
			} else {
				const customFieldCheckbox = container.find(`#customField${definition.fieldNumber}CheckboxDialog`);
				if (customFieldCheckbox.length) {
					if (!hasCustomFieldCheckboxChangeListener[definition.fieldNumber]) {
						addCustomFieldCheckboxChangeListener(container, definition.fieldNumber, hasCustomFieldCheckboxChangeListener);
					}
					setCustomFieldCheckboxValue(container, true, definition.fieldNumber);
				} else {
					customField.val("");
				}
			}
		}
	}
}

export function updateCustomFields(container: JQuery, recording: CustomFields, definitions: CustomFieldDefinition[], customFieldComboboxes: Combobox<CustomFieldOption>[], hasCustomFieldCheckboxChangeListener: boolean[]) {
	let i = 0;
	for (const definition of definitions) {
		const rawValue = recording[`customField${definition.fieldNumber}` as keyof CustomFields];
		const value = formatCustomField(rawValue, definition.fieldType);
		const customField = container.find(`[name="customField${definition.fieldNumber}"]`);
		switch (definition.fieldType) {
			case CustomFieldsForRecordType.Checkbox:
				if (!hasCustomFieldCheckboxChangeListener[definition.fieldNumber]) {
					addCustomFieldCheckboxChangeListener(container, definition.fieldNumber, hasCustomFieldCheckboxChangeListener);
				}
				setCustomFieldCheckboxValue(container, false, definition.fieldNumber, "true" === rawValue);
				break;
			case CustomFieldsForRecordType.Number:
				container.find(`[name="customField${definition.fieldNumber}Number"]`).val(value);
				break;
			case CustomFieldsForRecordType.Options:
				if (customField.hasClass("comboboxRow") && definition.fieldName && customFieldComboboxes[i]) {
					const items: CustomFieldOption[] = (definition.optionsList ?? [])
						.filter(item => item !== "")
						.map(item => ({id: item}));
					customFieldComboboxes[i].updateItems(items);
					if (rawValue !== null && rawValue !== "") {
						customFieldComboboxes[i].setSelectedItem({id: rawValue}, false, true);
					} else {
						customFieldComboboxes[i].clearSelection();
					}
					i++;
				}
				break;
			default:
				customField.val(value);
				break;
		}
	}
}

function setCustomFieldCheckboxValue(container: JQuery, init: boolean, fieldNumber: number, checked = false) {
	const customFieldCheckbox = container.find(`#customField${fieldNumber}CheckboxDialog`);
	const customFieldCheckboxHidden = container.find(`[name="customField${fieldNumber}"]`);
	if (init) {
		customFieldCheckboxHidden.val(false.toString());
	}
	customFieldCheckboxHidden.val(checked.toString());
	customFieldCheckbox.prop("checked", checked);
}

function addCustomFieldCheckboxChangeListener(container: JQuery, fieldNumber: number, hasCustomFieldCheckboxChangeListener: boolean[]) {
	const customFieldCheckbox = container.find(`#customField${fieldNumber}CheckboxDialog`);
	const customFieldCheckboxHidden = container.find(`[name="customField${fieldNumber}"]`);
	customFieldCheckbox.on("change", () => {
		customFieldCheckboxHidden.val(customFieldCheckbox.is(":checked").toString());
	});
	hasCustomFieldCheckboxChangeListener[fieldNumber] = true;
}
